import React from "react";
import { makeStyles } from "@material-ui/core/styles";
import Grid from "@material-ui/core/Grid";
// import ArrowBackIosIcon from "@material-ui/icons/ArrowBackIos";
import ChevronLeftIcon from "@material-ui/icons/ChevronLeft";
import { useHistory } from "react-router-dom";
import Typography from "@material-ui/core/Typography";
// import Button from "@material-ui/core/Button";

const useStyles = makeStyles({
	backWrapper: {
		marginTop: -6,
		paddingLeft: 24,
		textAlign: "left",
	},
	back: {
		cursor: "pointer",
	},
	title: {
		textAlign: "center",
	},
	innerTitle: {
		fontSize: 24,
		fontWeight: "bold",
	},
	rightTitle: {
		textAlign: "center",
		paddingTop: 6,
	},
	rightTitleButton: {
		color: "#fff",
	},
});

const TopBar = ({
	leftSide = "",
	title = "",
	rightSide = "",
	children,
	style = {},
}) => {
	const classes = useStyles();
	const hist = useHistory();
	return (
		<>
			<Grid item container style={{ ...style }}>
				<Grid item xs={3} className={classes.backWrapper}>
					{leftSide !== "" ? (
						<ChevronLeftIcon
							className={classes.back}
							onClick={() => {
								if (leftSide === "-1") hist.go(-1);
								else hist.push(leftSide);
							}}
							fontSize="large"
						/>
					) : null}
				</Grid>

				<Grid item xs={6} className={classes.title}>
					<Typography variant="h4" className={classes.innerTitle}>
						{title}
					</Typography>
				</Grid>

				<Grid item xs={3} className={classes.rightTitle}>
					{rightSide !== "" ? rightSide : null}
				</Grid>
			</Grid>
			{children}
		</>
	);
};

export default TopBar;
